export const MODAL_STEP = {
    mappingSettings: 'mappingSettings',
    testMapping: 'testMapping',
} as const;

export type InventoryCompareProductsModalStep = (typeof MODAL_STEP)[keyof typeof MODAL_STEP];

export const INITIAL_MODAL_STEP = MODAL_STEP.mappingSettings;
